(() => {
  const drawer = document.querySelector('m-cart-drawer.pp-cart-compact');
  if (!drawer || drawer.dataset.ppInitialized) return;
  drawer.dataset.ppInitialized = 'true';
  const panel = drawer.querySelector('[role="dialog"]');
  const checkout = drawer.querySelector('.pp-cart-checkout');
  const error = drawer.querySelector('[data-pp-cart-error]');
  let pending = false;
  let updating = false;
  let uncertain = false;
  let wasOpen = false;
  let opener;
  let scheduled = false;
  const touchQuantities = window.matchMedia('(hover: none) and (pointer: coarse)');
  const indiaDay = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: 'numeric', day: 'numeric' });
  const deliveryDate = new Intl.DateTimeFormat('en-IN', { timeZone: 'UTC', day: 'numeric', month: 'short' });
  let deliveryTimer;
  let lastDeliveryKey;
  const todayInIndia = () => {
    const parts = Object.fromEntries(indiaDay.formatToParts(new Date()).map(part => [part.type, part.value]));
    return new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
  };
  const deliveryDay = (start, days) => {
    const date = new Date(start);
    date.setUTCDate(date.getUTCDate() + days);
    return date;
  };
  const workingDay = (start, days) => {
    const date = new Date(start);
    while (days > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) days--;
    }
    return date;
  };
  const updateDelivery = () => {
    const row = drawer.querySelector('[data-pp-cart-delivery]');
    if (!row) return;
    const form = drawer.querySelector('[data-pp-item-count]');
    row.hidden = Number(form?.dataset.ppItemCount || 0) === 0 || form?.dataset.ppCartShipping === 'false';
    const today = todayInIndia();
    const terrarium = form?.dataset.ppTerrariumDelivery === 'true';
    const key = `${today.getTime()}:${terrarium}:${drawer.dataset.deliveryMin}:${drawer.dataset.deliveryMax}`;
    if (lastDeliveryKey === key) return;
    const minimum = Math.max(1, Math.min(10, Number(drawer.dataset.deliveryMin) || 3));
    const maximum = Math.max(minimum, Math.min(10, Number(drawer.dataset.deliveryMax) || 5));
    const earliest = terrarium ? workingDay(deliveryDay(today, 1), 2) : deliveryDay(today, minimum);
    const latest = terrarium ? workingDay(deliveryDay(today, 3), 5) : deliveryDay(today, maximum);
    const value = deliveryDate.format(earliest) + ' – ' + deliveryDate.format(latest);
    const range = row.querySelector('[data-pp-delivery-range]');
    if (range.textContent !== value) range.textContent = value;
    row.title = terrarium ? row.dataset.ppTerrariumDeliveryNote : row.dataset.ppDefaultDeliveryNote;
    lastDeliveryKey = key;
  };
  const startDeliveryClock = () => {
    clearTimeout(deliveryTimer);
    if (!drawer.classList.contains('m-cart-drawer--active')) return;
    const nextMidnight = todayInIndia().getTime() + 86400000 - 19800000;
    deliveryTimer = setTimeout(() => { updateDelivery(); startDeliveryClock(); }, Math.max(1000, nextMidnight - Date.now() + 250));
  };

  const syncQuantityInputs = () => {
    drawer.querySelectorAll('input[name="updates[]"]').forEach(input => {
      if (touchQuantities.matches && !input.hasAttribute('data-pp-touch-quantity')) {
        input.dataset.ppOriginalInputmode = input.getAttribute('inputmode') || '';
        input.dataset.ppOriginalReadonly = String(input.readOnly);
        input.dataset.ppTouchQuantity = '';
        input.readOnly = true;
        input.inputMode = 'none';
        if (document.activeElement === input) input.blur();
      } else if (!touchQuantities.matches && input.hasAttribute('data-pp-touch-quantity')) {
        input.readOnly = input.dataset.ppOriginalReadonly === 'true';
        if (input.dataset.ppOriginalInputmode) input.inputMode = input.dataset.ppOriginalInputmode;
        else input.removeAttribute('inputmode');
        delete input.dataset.ppTouchQuantity;
        delete input.dataset.ppOriginalInputmode;
        delete input.dataset.ppOriginalReadonly;
      }
    });
  };

  const visible = element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
  const controls = () => [...panel.querySelectorAll('button, a[href], input, textarea, select, summary, [tabindex="0"]')].filter(element => !element.disabled && visible(element));
  const showError = message => {
    error.textContent = typeof message === 'string' ? message : drawer.dataset.updateError;
    error.hidden = false;
    if (uncertain) {
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.dataset.ppRecover = '';
      retry.textContent = drawer.dataset.refreshLabel;
      retry.addEventListener('click', recover);
      error.append(retry);
    }
  };
  const sync = () => {
    syncQuantityInputs();
    updateDelivery();
    const mutationBlocked = pending || updating || uncertain || drawer.hasAttribute('data-pp-add-pending') || drawer.hasAttribute('data-pp-add-uncertain');
    drawer.querySelectorAll('.m-quantity button, .m-quantity input, m-cart-remove-button button').forEach(control => {
      if (mutationBlocked && !control.disabled) { control.dataset.ppWasEnabled = ''; control.disabled = true; }
      if (!mutationBlocked && control.hasAttribute('data-pp-was-enabled')) { delete control.dataset.ppWasEnabled; control.disabled = false; }
    });
    const count = Number(drawer.querySelector('[data-pp-item-count]')?.dataset.ppItemCount || 0);
    const countText = `${count} ${count === 1 ? drawer.dataset.itemOne : drawer.dataset.itemOther}`;
    const countLabel = drawer.querySelector('[data-pp-cart-count]');
    if (countLabel.textContent !== countText) countLabel.textContent = countText;
    drawer.classList.toggle('m-cart--empty', count === 0);
    const host = drawer.querySelector('.shiprocket-headless');
    const provider = host.querySelector('.sr-headless-checkout');
    drawer.classList.toggle('pp-cart-has-fastrr', Boolean(provider && getComputedStyle(host).display !== 'none'));
    if (provider) {
      const label = provider.querySelector('.sr-checkout-visible2');
      if (label && label.textContent !== drawer.dataset.checkoutLabel) label.textContent = drawer.dataset.checkoutLabel;
      if (provider.getAttribute('aria-label') !== drawer.dataset.checkoutLabel) provider.setAttribute('aria-label', drawer.dataset.checkoutLabel);
      const textContainer = provider.querySelector('.sr-button-text-container');
      if (textContainer && !textContainer.querySelector('svg')) textContainer.append(drawer.querySelector('[data-pp-checkout-arrow]').content.cloneNode(true));
    }
    const terms = drawer.querySelector('[name="agree_terms"]');
    const termsMissing = Boolean(terms && !terms.checked);
    drawer.classList.toggle('pp-cart-terms-required', termsMissing);
    for (const button of [checkout, provider].filter(Boolean)) {
      const blocked = pending || uncertain || drawer.hasAttribute('data-pp-add-pending') || drawer.hasAttribute('data-pp-add-uncertain') || termsMissing;
      button.disabled = blocked;
      button.toggleAttribute('data-pp-locked', blocked);
    }
    const open = drawer.classList.contains('m-cart-drawer--active');
    document.documentElement.classList.toggle('pp-cart-open', open);
    if (open && !wasOpen) {
      startDeliveryClock();
      opener = drawer.activeElement || document.activeElement;
      requestAnimationFrame(() => drawer.querySelector('.m-cart-drawer__close').focus({ preventScroll: true }));
    } else if (!open && wasOpen && panel.contains(document.activeElement) && opener?.isConnected) {
      opener.focus({ preventScroll: true });
    }
    if (!open) clearTimeout(deliveryTimer);
    wasOpen = open;
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  };
  const setPending = state => {
    pending = state;
    drawer.toggleAttribute('data-pp-pending', state);
    panel.setAttribute('aria-busy', String(state));
    sync();
  };
  const request = async (url, options = {}) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try { return await fetch(url, { ...options, signal: controller.signal }); }
    finally { clearTimeout(timeout); }
  };
  const regions = ['[data-minimog-cart-items]', '[data-minimog-cart-discounts]', '[data-cart-subtotal]', '[data-minimog-gift-wrapping]'];
  const render = html => {
    const hadFocus = panel.contains(document.activeElement);
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const sources = regions.map(selector => parsed.querySelector(selector));
    if (sources.some(source => !source)) throw new Error('Missing cart regions');
    regions.forEach((selector, index) => { drawer.querySelector(selector).innerHTML = sources[index].innerHTML; });
    sync();
    if (wasOpen && (hadFocus || pending) && !panel.contains(document.activeElement)) drawer.querySelector('.m-cart-drawer__close').focus({ preventScroll: true });
  };
  async function recover() {
    setPending(true);
    try {
      const url = new URL(window.MinimogSettings.routes.cart, location.origin);
      url.searchParams.set('section_id', 'cart-drawer');
      const response = await request(url);
      if (!response.ok) throw new Error('Cart refresh failed');
      render(await response.text());
      uncertain = false;
      drawer.removeAttribute('data-pp-add-uncertain');
      error.hidden = true;
    } catch (_) { uncertain = true; showError(drawer.dataset.confirmError); }
    finally { setPending(false); }
  }
  drawer.ppConfirmCart = recover;
  drawer.ppSyncCart = sync;
  drawer.ppCartBusy = () => pending || updating || uncertain || drawer.hasAttribute('data-pp-add-pending') || drawer.hasAttribute('data-pp-add-uncertain');
  customElements.whenDefined('m-cart-drawer-items').then(() => {
    const items = drawer.querySelector('m-cart-drawer-items');
    // Keep Minimog's quantity/remove controls and section contract; guard checkout until totals are confirmed.
    items.updateQuantity = async (line, quantity, name) => {
      if (updating || uncertain || drawer.hasAttribute('data-pp-add-pending') || drawer.hasAttribute('data-pp-add-uncertain')) return;
      const index = Number(line);
      const value = Number(quantity);
      if (!Number.isInteger(index) || index < 1 || !Number.isInteger(value) || value < 0) {
        const input = drawer.querySelector(`#MinimogDrawer-quantity-${line}`);
        if (input) input.value = input.getAttribute('value');
        setPending(false);
        showError(drawer.dataset.updateError);
        return;
      }
      updating = true;
      setPending(true);
      error.hidden = true;
      let response;
      try {
        response = await request(window.MinimogSettings.routes.cart_change_url, {
          ...window.fetchConfig(),
          body: JSON.stringify({ line: index, quantity: value, sections: ['cart-drawer'], sections_url: location.pathname }),
        });
        const result = await response.json();
        if (result.errors || !response.ok) {
          const input = drawer.querySelector(`#MinimogDrawer-quantity-${index}`);
          if (input) input.value = input.getAttribute('value');
          showError(result.description || result.errors || drawer.dataset.updateError);
          return;
        }
        render(result.sections['cart-drawer']);
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { ...result, source: 'main-cart-items' });
        const actual = result.items[index - 1]?.quantity;
        if (value > 0 && actual !== value) showError(window.MinimogStrings.quantityError.replace('[quantity]', actual || 0));
        if (wasOpen && name) drawer.querySelector(`#MinimogDrawer-quantity-${index}`)?.closest('.m-quantity')?.querySelector(`[name="${name}"]`)?.focus({ preventScroll: true });
      } catch (_) {
        // A lost response may still have changed the cart. Read it back; never blindly repeat the mutation.
        uncertain = true;
        await recover();
      } finally { updating = false; setPending(false); }
    };
    drawer.dataset.ppReady = 'true';
  });
  drawer.addEventListener('change', event => {
    if (event.target.matches('input[name="updates[]"]')) setPending(true);
    if (event.target.matches('[name="agree_terms"]')) sync();
  }, true);
  // A tap on the displayed count must not open a keyboard or zoom the cart.
  drawer.addEventListener('pointerdown', event => {
    if (touchQuantities.matches && event.target.matches('input[name="updates[]"]')) event.preventDefault();
  }, true);
  drawer.addEventListener('click', event => {
    if (event.target.closest('.sr-headless-checkout, .pp-cart-checkout') && (pending || uncertain || drawer.hasAttribute('data-pp-add-pending') || drawer.hasAttribute('data-pp-add-uncertain') || drawer.classList.contains('pp-cart-terms-required'))) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  drawer.addEventListener('submit', event => {
    if (pending || uncertain || drawer.hasAttribute('data-pp-add-pending') || drawer.hasAttribute('data-pp-add-uncertain') || drawer.classList.contains('pp-cart-terms-required')) event.preventDefault();
  });
  drawer.addEventListener('keydown', event => {
    if (!wasOpen || !panel.contains(event.target)) return;
    if (event.key === 'Escape') { event.preventDefault(); drawer.close(); }
    if (event.key !== 'Tab') return;
    const focusable = controls();
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && event.target === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && event.target === last) { event.preventDefault(); first?.focus(); }
  });
  new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-pp-add-pending', 'data-pp-add-uncertain'] });
  window.addEventListener('resize', schedule);
  touchQuantities.addEventListener('change', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { updateDelivery(); startDeliveryClock(); } });
  sync();
})();
